export default __webpack_public_path__ + "static/media/gallery_01.f4b6d9ce.jpg";